import { useQuery, type QueryClient } from "react-query";

import { API_URL } from "../config";

export const NAVIGATION_SUMMARY_QUERY_KEY = ["ui-navigation-summary"] as const;

export type NavigationSummary = {
  generatedAt: string;
  transferPendingCount: number | null;
  libraryUnreadDocumentCount: number | null;
};

const fetchNavigationSummary = async (): Promise<NavigationSummary> => {
  const response = await fetch(`${API_URL}/ui/navigation-summary`, {
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error(`Navigation summary request failed with HTTP ${response.status}`);
  }
  return response.json();
};

export const invalidateNavigationSummary = (queryClient: QueryClient) =>
  queryClient.invalidateQueries(NAVIGATION_SUMMARY_QUERY_KEY);

export const useNavigationSummary = (enabled: boolean) =>
  useQuery<NavigationSummary>(NAVIGATION_SUMMARY_QUERY_KEY, fetchNavigationSummary, {
    enabled,
    refetchInterval: enabled ? 60_000 : false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    retry: 1,
  });
